'use strict';

angular.module('atex.dam').controller('DamModalDlgController', [ '$scope', '$rootScope', 'preloader',
function($scope, $rootScope, preloader) {

  $scope.isLoading = false;

  if ($scope.inputTemplate.toLowerCase().includes("image") && $scope.url) {
    var imageLocations = [ $scope.url ];
    $scope.isLoading = true;
    // Preload the images; then, update display when returned.
    preloader.preloadImages(imageLocations).then(function handleResolve(imageLocations) {
      // Loading was successful.
      $scope.isLoading = false;
    }, function handleReject(imageLocation) {
      // Loading failed on at least one image.
      $scope.isLoading = false;
      console.error("Image Failed", imageLocation);
    }, function handleNotify(event) {
      //console.info( "Percent loaded:", event.percent );
    });
  } else {
    $scope.isLoading = false;
  }

} ]);
